import { List as AntList } from 'antd'
import Item from 'app/components/Core/Document/Item'
import React, { ComponentProps } from 'react'

type DocumentType = { title: string; url: string }

interface Props extends ComponentProps<typeof AntList> {
  documents: Array<DocumentType>
}

const List: React.FC<Props> = ({ documents, ...others }) => {
  return (
    <AntList
      itemLayout="horizontal"
      dataSource={documents}
      renderItem={(item: DocumentType) => (
        <div className="mb-2">
          <Item title={item.title} url={item.url} />
        </div>
      )}
      {...others}
    />
  )
}

export default List
